import { FormEventHandler } from "react"
import PasswordCreateView from "./PasswordCreateView"
import { useCreatePasswordAction } from "./api/action"

const PasswordCreateViewContainer = ({
  onContinue,
  onCancel,
  showHeading
}: {
  onContinue: Function
  onCancel?: Function
  showHeading?: boolean
}) => {
  const [state, action] = useCreatePasswordAction()

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    await action(formData)
  }

  return (
    <PasswordCreateView
      data={state.value}
      loading={state.loading}
      success={!!state.value}
      error={state.error?.message}
      onSubmit={handleSubmit}
      onContinue={onContinue}
      onCancel={onCancel}
      showHeading={showHeading}
    />
  )
}

export default PasswordCreateViewContainer
